import { Button } from 'antd';
import React, { memo, useState, useEffect, useCallback } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import styles from './index.module.less' // 导入样式文件

const Index = (props: any) => {
    const [isDebugMode, setIsDebugMode] = useState(false);
    const navigate = useNavigate()
    const location = useLocation()
    const [searchParams] = useSearchParams()
    const isdebug = searchParams.get('isdebug') === '1'
    useEffect(() => {
        setIsDebugMode(isdebug)
    }, [isdebug]);

    // 关闭调试模式
    const closeDebugMode = () => {
        setIsDebugMode(false);
        // 更新 URL，去掉 isdebug=1
        const currentHash = window.location.hash; // e.g. '#/project-center/list?isdebug=1'
        // 如果 hash 中有查询参数
        if (currentHash.includes('?')) {
            // 拆分 hash 成路径和查询参数两部分
            if (searchParams.has('isdebug')) {
                searchParams.delete('isdebug');
                // 重新构建 hash (路径 + 新的查询参数)
                const newQuery = `${searchParams.toString() ? '?' + searchParams.toString() : ''}`;
                const newUrl = `${location.pathname}${newQuery}`;
                const newFullUrl = `${window.location.origin}${location.pathname}${newQuery}`;
                console.log("location", location.pathname)
                // navigate(newUrl)
                window.location.href = newFullUrl;
            }
        }
    };
    return (<div>
        {/* 如果开启调试模式，则显示调试信息 */}
        {isDebugMode && (
            <div className={styles["debug-bar"]}>
                {/* <span>调试</span>
                <div className={styles["wave-container"]}>
                    <button onClick={closeDebugMode} className={styles["wave-button"]}>关闭调试</button>
                </div> */}
                <Button type='primary' onClick={closeDebugMode}>关闭调试</Button>
            </div>
        )}
    </div>
    )
}

export default Index